import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { useIntl } from 'react-intl'
import _ from 'lodash'

import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import TitleIcon from 'core/layouts/title-icon'
import useGetCar from 'core/hooks/useGetCar'
import { Col, Row } from 'core/components/ui'

import { tradeInShape } from '../shapes'

import { getFormFields, getRequiredFields } from './fields-structure'
import FORM_FIELDS_TYPE from './fields-structure/constants'

const State = props => {
  const intl = useIntl()
  const { history, setWizards, wizards, tradeIn, setTradeIn } = props
  const { vehicle } = tradeIn

  const { loading, getParamsTyresTypeQuestion, paramsTyresTypeQuestion } = useGetCar({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_STATE) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  const handleChange = extendedVehicle => {
    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  useEffect(() => {
    if (getRequiredFields(vehicle).every(x => x !== undefined && x !== null && x !== '')) {
      activateNextStep()
    }
  }, [vehicle])

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.TRADEIN_STATE)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }
  }, [])

  return (
    <MainContentWrapper>
      {getFormFields(FORM_FIELDS_TYPE.WEAR).map((categories, i) => (
        <React.Fragment key={i}>
          <TitleIcon
            cssId="globaldealer-title-7"
            title={intl.formatMessage({
              id: 'tradeIn-state-subtitle-1'
            })}
          />

          {categories.nodes.map((FormItem, index) => (
            <FormItem key={index} onChange={handleChange} vehicle={vehicle} />
          ))}
        </React.Fragment>
      ))}

      {getFormFields(FORM_FIELDS_TYPE.ADDITIONAL_INFORMATION).map((categories, i) => (
        <React.Fragment key={i}>
          <TitleIcon
            cssId="globaldealer-title-13"
            title={intl.formatMessage({
              id: 'tradeIn-state-subtitle-2'
            })}
          />

          {categories.nodes.map((FormItem, index) => (
            <FormItem
              key={index}
              onChange={handleChange}
              vehicle={vehicle}
              loading={loading}
              paramsTyresTypeQuestion={paramsTyresTypeQuestion}
              getParamsTyresTypeQuestion={getParamsTyresTypeQuestion}
            />
          ))}
        </React.Fragment>
      ))}

      {!!vehicle.secondTyres &&
        !!vehicle.tyresType &&
        getFormFields(FORM_FIELDS_TYPE.SECOND_WEAR).map((categories, i) => (
          <React.Fragment key={i}>
            <TitleIcon
              cssId="globaldealer-title-14"
              title={intl.formatMessage(
                {
                  id: 'tradeIn-state-subtitle-3'
                },
                {
                  type:
                    paramsTyresTypeQuestion.find(x => x.key !== vehicle.tyresType) &&
                    _.lowerCase(
                      paramsTyresTypeQuestion.find(x => x.key !== vehicle.tyresType).value
                    )
                }
              )}
            />

            <Row gutter={30}>
              {categories.nodes.map((FormItem, index) => (
                <Col xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 12 }} key={index}>
                  <FormItem onChange={handleChange} vehicle={vehicle} />
                </Col>
              ))}
            </Row>
          </React.Fragment>
        ))}
    </MainContentWrapper>
  )
}

State.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  tradeIn: tradeInShape.isRequired,
  setTradeIn: PropTypes.func.isRequired
}

export default withRouter(State)
